/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrition-order.reducer';

export const NutritionOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionOrderEntity = useAppSelector(state => state.nutritionOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionOrder.detail.title">NutritionOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.id}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="recomendation">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.recomendation">Recomendation</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.recomendation}</dd>
          <dt>
            <span id="mealType">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.mealType">Meal Type</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.mealType}</dd>
          <dt>
            <span id="mealStatus">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.mealStatus">Meal Status</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.mealStatus}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.orderStatus}</dd>
          <dt>
            <span id="feedType">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.feedType">Feed Type</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.feedType}</dd>
          <dt>
            <span id="entralType">
              <Translate contentKey="tinyMedicRestApp.nutritionOrder.entralType">Entral Type</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderEntity.entralType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.fulfilledBy">Fulfilled By</Translate>
          </dt>
          <dd>{nutritionOrderEntity.fulfilledBy ? nutritionOrderEntity.fulfilledBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{nutritionOrderEntity.treatmentPlan ? nutritionOrderEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionOrder.createdBy">Created By</Translate>
          </dt>
          <dd>{nutritionOrderEntity.createdBy ? nutritionOrderEntity.createdBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nutrition-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrition-order/${nutritionOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionOrderDetail;
